import Vue from 'vue'
import Router from 'vue-router'
import { getParentToken, rememberParentLoginRedirect } from '../utils/parentAuth'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

const routes = [
  // 默认登陆
  {
    path: '/',
    redirect: '/calendar'
  },
  //登录
  {
    path: '/login',
    name: 'login',
    component: () => import( /* webpackChunkName:'login'*/ '@/pages/login/login'),
    meta: {
      title: ''
    }
  },
  // 班级欢迎页
  {
    path: '/welcomeClass',
    name: 'welcomeClass',
    component: () => import( /* webpackChunkName:'welcomeClass'*/ '@/pages/welcomeClass/welcomeClass'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 失败的欢迎页面
  {
    path: '/welcomeClassError',
    name: 'welcomeClassError',
    component: () => import( /* webpackChunkName:'welcomeClassError'*/ '@/pages/welcomeClass/welcomeClassError'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 设置密码
  {
    path: '/setPassWord',
    name: 'setPassWord',
    component: () => import( /* webpackChunkName:'setPassWord'*/ '@/pages/setPassWord/setPassWord'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
    //首页日历
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import( /* webpackChunkName:'calendar'*/ '@/pages/calendar/calendar'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 首页今天消息页
  {
    path: '/todayMessage',
    name: 'todayMessage',
    component: () => import( /* webpackChunkName:'todayMessage'*/ '@/pages/todayMessage/todayMessage'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 课后练习
  {
    path: '/afterClass',
    name: 'afterClass',
    component: () => import( /* webpackChunkName:'afterClass'*/ '@/pages/afterClass/afterClass'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 曲目拓展
  {
    path: '/repertoireExpansion',
    name: 'repertoireExpansion',
    component: () => import( /* webpackChunkName:'repertoireExpansion'*/ '@/pages/repertoireExpansion/repertoireExpansion'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 个人中心
  {
    path: '/personalCenter',
    name: 'personalCenter',
    component: () => import( /* webpackChunkName:'personalCenter'*/ '@/pages/personalCenter/personalCenter'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 日练习时长
  {
    path: '/practiceDuration',
    name: 'practiceDuration',
    component: () => import( /* webpackChunkName:'practiceDuration'*/ '@/pages/practiceDuration/practiceDuration'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 月报告
  {
    path: '/monthlyReport',
    name: 'monthlyReport',
    component: () => import( /* webpackChunkName:'monthlyReport'*/ '@/pages/monthlyReport/monthlyReport'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 周报告
  {
    path: '/weekReport',
    name: 'weekReport',
    component: () => import( /* webpackChunkName:'weekReport'*/ '@/pages/weekReport/weekReport'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
    //日联系报告
  {
    path: '/exerciseReport',
    name: 'exerciseReport',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/exerciseReport/exerciseReport'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
    // 分享
  {
    path: '/shareExercise',
    name: 'shareExercise',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/shareExercise/shareExercise'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
    // 加入学校
  {
    path: '/newGoSchool',
    name: 'newGoSchool',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/newGoSchool/newGoSchool'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 加入学校
  {
    path: '/goSchool',
    name: 'goSchool',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/goSchool/goSchool'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 作业报告
  {
    path: '/homeworkReport',
    name: 'homeworkReport',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/homeworkReport/homeworkReport'),
    meta: {
      title: '',
      requireAuth: true
    }
  }
];
const router = new Router({
  routes
});
// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (getParentToken()) {
      next();
    } else {
      if(to.name == 'shareExercise'){
        next();
      }else {
        rememberParentLoginRedirect(to.fullPath);
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      }
    }
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js